const TOKEN_STORAGE_KEY = 'argos-panoptes-jwt-token'

export const tokenUtils = {
  /**
   * Save JWT token to localStorage
   */
  saveToken: (token: string): void => {
    try {
      localStorage.setItem(TOKEN_STORAGE_KEY, token)
    } catch (error) {
      console.warn('Failed to save token to localStorage:', error)
    }
  },

  /**
   * Get JWT token from localStorage
   */
  getToken: (): string | null => {
    try {
      return localStorage.getItem(TOKEN_STORAGE_KEY)
    } catch (error) {
      console.warn('Failed to get token from localStorage:', error)
      return null
    }
  },

  /**
   * Remove JWT token from localStorage
   */
  removeToken: (): void => {
    try {
      localStorage.removeItem(TOKEN_STORAGE_KEY)
    } catch (error) {
      console.warn('Failed to remove token from localStorage:', error)
    }
  },

  /**
   * Check if token is expired (basic JWT parsing)
   * Returns true if token is expired or invalid
   */
  isTokenExpired: (token: string): boolean => {
    try {
      // Validate JWT format (should have 3 parts separated by dots)
      const parts = token.split('.')
      if (parts.length !== 3) {
        console.warn('Invalid JWT format: expected 3 parts')
        return true
      }

      const payload = JSON.parse(atob(parts[1]))
      const currentTime = Math.floor(Date.now() / 1000)

      // If no expiration time, consider token as non-expiring (shouldn't happen in our case)
      if (!payload.exp) {
        console.warn('JWT token has no expiration time')
        return false
      }

      return payload.exp < currentTime
    } catch (error) {
      console.warn('Failed to parse token:', error)
      return true
    }
  },

  /**
   * Get valid token from storage (removes if expired)
   */
  getValidToken: (): string | null => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY)
    if (!token) return null

    if (tokenUtils.isTokenExpired(token)) {
      tokenUtils.removeToken()
      return null
    }

    return token
  },
}
